import React from 'react';
import {Divider} from '@material-ui/core';
import useCategorias from '../../Hooks/useCategorias';
import Loader from "../../Components/Loader";
import Categoria from '../../Components/Menu/Categoria';

const Categorias = () => 
{
    const CategoriasList =useCategorias();

    if (CategoriasList.length === 0)
    {
        return <Loader/>
    }

    return <section>
        {CategoriasList.map(categoria =>
        {
            return <div>
                <Categoria categoria={categoria}/>
                <Divider/>
            </div>
        })}
    </section>
}


export default Categorias